<template>
  <div class="mx-auto flex flex-col items-center">
    <img
      class="mb-10 hidden md:block"
      :src="isAppInstalled ? openAppIllustration.src : downloadAppIllustration.src"
      alt=""
    />

    <img class="mb-6 block md:hidden" :src="mobileIllustration.src" alt="" />

    <h1 class="mb-5 font-serif text-4.5xl font-bold leading-12">{{ title }}</h1>

    <div class="hidden md:block">
      <div class="text-lg">
        <template v-if="isAppInstalled">
          <div>{{ t("pages.subscribe.subpage-thanks.open-app.description") }}</div>

          <div>
            {{ t("pages.subscribe.subpage-thanks.open-app.description-2nd-line") }}
            <IAILink :url="appLink" :text="t('pages.subscribe.subpage-thanks.open-app.click-here')" />
          </div>
        </template>

        <template v-else>
          <div class="mb-8">{{ t("pages.subscribe.subpage-thanks.download.description") }}</div>

          <div class="flex gap-x-6">
            <IAIButton
              class="w-60"
              :label="t('pages.subscribe.subpage-thanks.download.mac-btn-label')"
              variant="secondary"
              @click="download({ os: 'mac' })"
            />

            <IAIButton
              class="w-60"
              :label="t('pages.subscribe.subpage-thanks.download.win-btn-label')"
              variant="secondary"
              @click="download({ os: 'windows' })"
            />
          </div>
        </template>
      </div>
    </div>

    <div class="block px-16 md:hidden">
      <div>{{ t("pages.subscribe.subpage-thanks.mobile.description") }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import openAppIllustration from "@/features/subscribe/assets/open-app.svg";
import downloadAppIllustration from "@/features/subscribe/assets/download-app.svg";
import mobileIllustration from "@/features/subscribe/assets/mobile-thanks.svg";
import { IAIButton, IAILink } from "@/core-ui-vue";
import { t } from "@/locales/vue";
import { useAppInstallation } from "../services/useAppInstalled";

const props = withDefaults(
  defineProps<{
    title?: string;
    deepLinkPath?: string;
  }>(),
  {
    title: "",
    deepLinkPath: "",
  }
);

const { isAppInstalled, download, appLink } = useAppInstallation(props.deepLinkPath);
</script>
